import { FORM_TYPE } from "../custom-define-type";
import {
    DEFAULT_REQUEST_TIME_OFF_CATEGORIES,
    DEFAULT_SCHEDULE_EVENT_TYPES,
    DEFAULT_CANDIDATE_CLIENT_RELATIONSHIP_STATUS,
    DEFAULT_RELATIONSHIP_STATUSES_HIDDEN_MY_CANDIDATES
} from "../default-values"

export const EVALUATION_BUILDER_SETTINGS = [
    {
        key: "EVALUATION_BUILDER_OUTCOME",
        model: "public_advance_setting.candidate_can_see_evaluation_outcome",
        type: FORM_TYPE.CHECKBOX_ITEM,
    },
]

export const REQUEST_TIME_OFF_CATEGORIES_SETTINGS = [
    {
        key: "REQUEST_TIME_OFF_CATEGORIES",
        type: FORM_TYPE.LIST_TEXTFIELD_INPUT,
        model: 'public_advance_setting.time_off_categories',
        default: DEFAULT_REQUEST_TIME_OFF_CATEGORIES
    },
]

export const CANDIDATE_TOGGLE_TABLE_VIEW_SETTINGS = [
    {
        key: "CANDIDATE_TOGGLE_TABLE_VIEW",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'public_advance_setting.candidate_default_table_view'
    },
]

export const DO_NOT_SHOW_DUPLICATED_DOCUMENTS_SETTINGS = [
    {
        key: "DO_NOT_SHOW_DUPLICATED_DOCUMENTS",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'public_advance_setting.do_not_show_duplicated_documents_updating_status'
    },
]

export const SCHEDULE_EVENT_TYPE_SETTINGS = [
    {
        key: "SCHEDULE_EVENT_TYPES",
        type: FORM_TYPE.LIST_TEXTFIELD_INPUT,
        model: 'public_advance_setting.schedule_Event_types',
        default: DEFAULT_SCHEDULE_EVENT_TYPES
    }
]

export const NOTIFY_EMAILS_RECURRING_AVAILABILITY_SETTINGS = [
    {
        key: "NOTIFY_EMAILS_RECURRING_AVAILABILITY",
        type: FORM_TYPE.LIST_TEXTFIELD_INPUT,
        model: 'advance_setting.notify_emails_candidate_change_recurring_availability'
    },
    {
        key: "ALLOW_CANDIDATE_TO_EDIT_RECURRING_AVAILABILITY",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: "advance_setting.allow_candidate_to_edit_recurring_availability",
        default: false
    },
    {
        key: "NUMBER_OF_WEEKS_CANDIDATE_CANNOT_CHANGE_WEEK_AVAILABILITY",
        isIntegerField: true,
        model: "advance_setting.number_weeks_change_schedule_effect",
        default: 0
    },
    {
        key: "CANDIDATE_TYPES_CANNOT_EDIT_RECURRING_AVAILABILITY",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        hasClearButton: true,
        closeOnSelect: false,
        model: 'advance_setting.candidate_types_cannot_edit_recurring_availability',
        optionListModel: 'candidate_types',
        default: []
    }
]

export const DAILY_AVAILABILITY_SETTINGS = [
    {
        key: "PREVENT_CANDIDATE_FROM_INPUTTING_DAILY_AVAILABILITY",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.prevent_candidates_inputting_daily_availability'
    },
]

export const TIMEOFF_RECORD_SETTINGS = [
    {
        key: "USE_TIMEOFF_CREDIT",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.use_timeoff_credit'
    },
]

export const SHOW_PRICE_MANAGER_ON_ADMINISTRATORS_TABLE = [
    {
        key: "SHOW_PRICE_MANAGER_ON_ADMINISTRATORS_TABLE",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.show_price_manager_on_administrators_table'
    },
]

export const CANDIDATE_MENU_ITEMS_LABEL_SETTINGS = [
    {
        key: "WORD_USED_FOR_MY_PROFILE",
        model: "public_advance_setting.word_used_for_my_profile",
        type: FORM_TYPE.TEXTBOX,
    },
    {
        key: "WORD_USED_FOR_AVAILABLE_JOBS",
        model: "public_advance_setting.word_used_for_available_jobs",
        type: FORM_TYPE.TEXTBOX,
    },
    {
        key: "WORD_USED_FOR_MY_SCHEDULE",
        model: "public_advance_setting.word_used_for_my_schedule",
        type: FORM_TYPE.TEXTBOX,
    },
    {
        key: "WORD_USED_FOR_MY_JOBS",
        model: "public_advance_setting.word_used_for_my_jobs",
        type: FORM_TYPE.TEXTBOX,
    },
    {
        key: "WORD_USED_FOR_MY_FAMILIES",
        model: "public_advance_setting.word_used_for_my_families",
        type: FORM_TYPE.TEXTBOX,
    }
]

export const CANDIDATE_CLIENT_RELATIONSHIP_STATUS_SETTINGS = [
    {
        key: "CUSTOMIZE_CANDIDATE_CLIENT_RELATIONSHIP_STATUS",
        type: FORM_TYPE.LIST_TEXTFIELD_INPUT,
        model: 'advance_setting.candidate_client_relationship_status',
        default: DEFAULT_CANDIDATE_CLIENT_RELATIONSHIP_STATUS,
        hasInitElement: false
    },
]

export const PLACEMENT_JOB_APPLICATION_AUTO_ADDING_RELATIONSHIP_SETTING = [
    {
        key: "PLACEMENT_JOB_APPLICATION_STATUS_TO_ADD_RELATIONSHIP",
        type: FORM_TYPE.MULTI_SELECT,
        model: "advance_setting.placement_application_status_auto_add_relationship_default",
        isMulti: true,
    }
]

export const CANDIDATE_CAN_EDIT_BUFFER_TIME = [
    {
        key: "CANDIDATE_CAN_EDIT_BUFFER_TIME",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.candidate_can_edit_buffer_time'
    },
]

export const REMOVE_CANDIDATE_UPLOAD_ADDITIONAL_DOCUMENT_BUTTON_SETTING = [
    {
        key: "REMOVE_CANDIDATE_UPLOAD_ADDITIONAL_DOCUMENT_BUTTON",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.remove_candidate_upload_additional_document_button'
    },
    {
        key: "REMOVE_CLIENT_UPLOAD_ADDITIONAL_DOCUMENT_BUTTON",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.remove_client_upload_additional_document_button'
    },
]

export const AGENCY_GETS_NOTIFIED_WHEN_CANDIDATE_UPLOAD_ANY_DOCUMENT = [
    {
        key: "AGENCY_GETS_NOTIFIED_WHEN_CANDIDATE_UPLOAD_ANY_DOCUMENT",
        type: FORM_TYPE.CHECKBOX_ITEM,
        model: 'advance_setting.agency_gets_notified_when_candidate_upload_any_document'
    },
]

export const MY_CANDIDATES_SETTINGS = [
    {
        key: "CLIENT_ADD_NOTE_ASSIGNED_CANDIDATE_NOTIFICATION_EMAILS",
        type: FORM_TYPE.LIST_TEXTFIELD_INPUT,
        model: 'advance_setting.client_add_note_assigned_candidate_notification_emails',
        hasInitElement: false,
    },
    {
        key: "WORD_USED_FOR_SCHEDULE_INTERVIEW_RELATIONSHIP",
        model: "public_advance_setting.word_used_for_schedule_interview_relationship",
        type: FORM_TYPE.TEXTBOX,
        default: 'Schedule Interview'
    },
    {
        key: "SHOW_SHAREABLE_LINK_FOR_MY_CANDIDATES_SECTION",
        model: "public_advance_setting.show_shareable_link_for_my_candidates_section",
        type: FORM_TYPE.CHECKBOX_ITEM
    },
    {
        key: "RELATIONSHIP_STATUSES_WHERE_EXTEND_OFFER_BUTTON_APPEARS",
        model: "advance_setting.relationship_statuses_where_extended_offer_button_appears",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        default: ['Interested'],
        optionListModel: 'advance_setting.candidate_client_relationship_status',
    },
    {
        key: "RELATIONSHIP_STATUSES_HIDDEN_IN_MY_CANDIDATES",
        model: "advance_setting.relationship_statuses_hidden_my_candidates",
        type: FORM_TYPE.MULTI_SELECT,
        isMulti: true,
        default: DEFAULT_RELATIONSHIP_STATUSES_HIDDEN_MY_CANDIDATES,
        optionListModel: 'advance_setting.candidate_client_relationship_status',
    }
]

export const NOTIFY_EMAILS_PACKAGE_SELECTION_CHANGE_SETTINGS = [
    {
        key: "NOTIFY_EMAILS_PACKAGE_SELECTION_CHANGE",
        type: FORM_TYPE.LIST_TEXTFIELD_INPUT,
        model: 'advance_setting.notify_emails_package_select_or_change',
    }
]

export const WORD_USED_FOR_SHIFT_JOB_CALENDAR_SETTINGS = [
    {
        key: "WORD_USED_FOR_SHIFT_JOB_CALENDAR",
        model: "public_advance_setting.word_used_for_shift_job_calendar",
        type: FORM_TYPE.TEXTBOX,
    },
]

export const WORD_USED_FOR_PLACEMENT_JOB_SETTINGS = [
    {
        key: "WORD_USED_FOR_PLACEMENT_JOB",
        model: "public_advance_setting.word_used_for_job_placement",
        type: FORM_TYPE.TEXTBOX,
    },
]

export const WORD_USED_FOR_CANDIDATE_SETTINGS = [
    {
        key: "WORD_USED_FOR_CANDIDATE",
        model: "public_advance_setting.word_used_for_candidate",
        type: FORM_TYPE.TEXTBOX,
    },
    {
        key: "WORD_USED_FOR_CANDIDATES",
        model: "public_advance_setting.word_used_for_candidates",
        type: FORM_TYPE.TEXTBOX,
    },
]

export const WORD_USED_FOR_CLIENT_SETTINGS = [
    {
        key: "WORD_USED_FOR_CLIENT",
        model: "public_advance_setting.word_used_for_client",
        type: FORM_TYPE.TEXTBOX,
    },
    {
        key: "WORD_USED_FOR_CLIENTS",
        model: "public_advance_setting.word_used_for_clients",
        type: FORM_TYPE.TEXTBOX,
    },
]


// WEBPACK FOOTER //
// ./src/constants/agency-settings/general-settings.js